<template>
    <b-container class="my-4">
        <b-row class="justify-content-center">
            <b-col cols="12" md="7" lg="5">
                <div class="bg-white p-4 rounded">
                    <div class="text-left">
                        <img src="../../../public/img/logo-full.png" width="200"/>
                    </div>
                    <div class="text-center mt-4">
                        <h1 class="font-weight-bold mb-0">BILL PAY</h1>
                    </div>
                    <hr/>
                    <div class="w-75 m-auto text-center">
                        <h6 class="text-center font-weight-bold">Sette Osteria</h6>
                        <p class="mb-0 text-muted">
                            1666 Connecticute Ave, NW Washington, DC 20009 P (202) 483-3070
                        </p>
                        <p class="mb-0 text-dark font-weight-bold mt-4">
                            Tab No 1002 Pickup for April 4,2021 10:30PM
                        </p>
                        <p class="mt-4 mb-0 text-muted">
                            Ordered on April 04, 2021 03:51PM
                        </p>
                        <p class="mt-1 text-muted">
                            Name: John kingdom
                        </p>
                    </div>
                    <div class="w-100">
                        <p class="text-danger font-weight-bold">
                            NOTE: Pay ASAP for on time pickup.Late payment results in pickup delay or order cancellation
                        </p>
                    </div>
                    <div class="text-center bg-secondary p-4">
                        <p class="mb-0 small">
                            By payment I agree to MENUPOLY Terms of Use and Privacy Policy
                        </p>
                        <b-btn variant="danger" block class="mt-3">
                            Add Payment
                        </b-btn>
                    </div>
                    <div class="subTotal-section mt-3 p-2">
                        <div class="d-flex flex-row justify-content-between">
                            <span>
                                Subtotal <span @click="showDetails = !showDetails" class="cursor-pointer font-weight-bold" style="color: #595c87">(See details)</span>
                            </span>
                            <span>$46.98</span>
                        </div>
                        <b-collapse v-model="showDetails" class="border-top border-secondary mt-2">
                            <div class="d-flex flex-row justify-content-between mt-2">
                                <p class="mb-0">
                                    <span>1x Mozzarella Alla Carprese</span>
                                </p>
                                <p class="mb-0">
                                    $15.99
                                </p>
                            </div>
                            <div class="d-flex flex-row justify-content-between mt-2">
                                <p class="mb-0">
                                    <span>1x Mozzarella Alla Carprese</span>
                                </p>
                                <p class="mb-0">
                                    $15.99
                                </p>
                            </div>
                            <div class="d-flex flex-row justify-content-between mt-2">
                                <p class="mb-0">
                                    <span>1x Mozzarella Alla Carprese</span>
                                </p>
                                <p class="mb-0">
                                    $15.99
                                </p>
                            </div>
                        </b-collapse>
                    </div>
                    <div class="items p-2">
                        <div class="d-flex flex-row justify-content-between">
                            <span>
                                Tax (Including $1.37 Alcohol Tax)
                            </span>
                            <span>
                                $3.45
                            </span>
                        </div>
                        <div class="d-flex flex-row justify-content-between align-items-center">
                            <span>
                                Tip
                                <select>
                                    <option>15%</option>
                                    <option>20%</option>
                                </select>
                            </span>
                            <span>
                                $7.45
                            </span>
                        </div>
                        <div class="d-flex flex-row justify-content-between">
                            <span class="font-weight-bold">
                                Delivery Fee
                            </span>
                            <span>
                                $2.00
                            </span>
                        </div>
                        <div class="d-flex flex-row justify-content-between">
                            <span>
                                Tech Fee
                            </span>
                            <span>
                                $1.75
                            </span>
                        </div>
                        <hr/>
                        <div class="d-flex font-weight-bold flex-row justify-content-between">
                            <span>
                                Total
                            </span>
                            <span>
                                $59.23
                            </span>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        name: "index",
        data () {
            return {
                showDetails: false
            }
        }
    }
</script>

<style scoped>
    .subTotal-section{
        background: #ffffd3;
    }
</style>
